"use client";

import { ShopCart } from "@/lib/cart/cart-types";
import { useCartStore } from "@/state-management/stores/cart-store";
import React from "react";

export function CartInitializer({ cartPromise }: { cartPromise: Promise<ShopCart | undefined> }) {
    React.useEffect(() => {
        const initCart = async () => {
            const cart = await cartPromise;
            useCartStore.getState().initialize(cart);
        };
        initCart();
    }, [cartPromise]);

    return null;
}
